import Vue from 'vue'
import { apolloClient } from '@/apollo'
import gql from 'graphql-tag'

export const fetchTaxonomiesQuery = gql`
  query SearchTaxonomies {
    taxonomy(order_by: {created_at: desc}) {
      id
      name
      is_default
      created_at
      description
    }
  }
`
const taxonomy = {
  namespaced: true,
  state: {
    taxonomies: []
  },
  actions: {
    async fetchAll ({ commit }) {
      try {
        const requestQuery = {
          query: fetchTaxonomiesQuery
        }

        const result = await apolloClient.query(requestQuery)
        if (result && result.data) {
          commit('SET_TAXONOMIES', result.data.taxonomy)
        }
      } catch (err) {
        window.console.error(err)
      }
    }
  },
  mutations: {
    SET_TAXONOMIES (state, data) {
      Vue.set(state, 'taxonomies', data)
    }
  },
  getters: {
    taxonomiesInfo: state => state.taxonomies
  }
}

export default taxonomy



// WEBPACK FOOTER //
// ./src/store/modules/taxonomy.js